import type * as React from 'react';
import { useTranslation } from 'react-i18next';

export interface SunlightSimulationViewProps {
  title?: string;
  url: string;
}

export const SunlightSimulationView: React.FC<SunlightSimulationViewProps> = ({
  title = 'sunlight-simulation',
  url,
}) => {
  const { t } = useTranslation();
  const translatedTitle = t(title);
  return (
    <>
      {title ? (
        <div className="px-4 pb-1 pt-2 sm:px-6">
          <h3 className="text-m font-semibold text-primary-light">{translatedTitle}</h3>
        </div>
      ) : null}
      <div className="max-h-[80vh] overflow-hidden p-2 sm:p-4 md:p-6">
        <iframe
          className="h-[80vh] w-full rounded-lg md:h-[75vh]"
          src={url}
          title={translatedTitle}
        />
      </div>
    </>
  );
};
